/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import type {NoteId, NoteInput, SupplierId} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getAddSupplierNoteUrl = (id: SupplierId) => {
  return `/api/v1/engineering/suppliers/${id}/notes`;
};

/**
 * @summary Add supplier note
 */
export const addSupplierNote = async (
  id: SupplierId,
  noteInput: NoteInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<NoteId> => {
  return customFetch<NoteId>(getAddSupplierNoteUrl(id), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(noteInput),
  });
};

export const getEditSupplierNoteUrl = (id: SupplierId, noteId: NoteId) => {
  return `/api/v1/engineering/suppliers/${id}/notes/${noteId}`;
};

/**
 * @summary Edit supplier note
 */
export const editSupplierNote = async (
  id: SupplierId,
  noteId: NoteId,
  noteInput: NoteInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getEditSupplierNoteUrl(id, noteId), {
    ...options,
    method: "PUT",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(noteInput),
  });
};

export const getRemoveSupplierNoteUrl = (id: SupplierId, noteId: NoteId) => {
  return `/api/v1/engineering/suppliers/${id}/notes/${noteId}`;
};

/**
 * @summary Remove supplier note
 */
export const removeSupplierNote = async (
  id: SupplierId,
  noteId: NoteId,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getRemoveSupplierNoteUrl(id, noteId), {
    ...options,
    method: "DELETE",
  });
};
